export function encryptParams(p) {
  if (p) {
    console.log("HTTP REQUEST: ", p);
  }

  return p;
}